export default "__VITE_ASSET__BGInxT4K__"